import { render, staticRenderFns } from "./custome.vue?vue&type=template&id=30a4d746&scoped=true&"
import script from "./custome.vue?vue&type=script&lang=js&"
export * from "./custome.vue?vue&type=script&lang=js&"
import style0 from "./custome.vue?vue&type=style&index=0&id=30a4d746&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30a4d746",
  null
  
)

export default component.exports